module.exports = "https://static.wmbcdn.com/uniweb/images/3366c77784cbd0b46a17792286f63c9b.svg";